module.exports = __webpack_public_path__ + "img/screenfull-Derror.ad584d78.png";